
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import $$ from 'dom7';
var restaurants_order = "default";
var restaurants_name = "";
var restaurants_payment = "";
var restaurants_tag = "";
var restaurant_open = 1;
var tagArray = new Array();
var tagSearchArray = new Array();
export default {
  data() {
    return;
    {
      data: null;
    }
  },

  on: {
    pageBeforeIn: function (e, page) {
      var _self = this;

      var _app = _self.$app;
      var _route = _self.$route;
    },
    pageAfterIn: function (e, page) {
      var _self = this;

      var _app = _self.$app;
      var _route = _self.$route;
      console.log("route /restaurants/");
      let _request_params = {
        'latitude': mapManager.Current_Location.lat,
        'longitude': mapManager.Current_Location.lng,
        'restaurants_order': restaurants_order,
        'restaurants_payment': restaurants_payment,
        'restaurants_tag': restaurants_tag,
        'restaurants_name': restaurants_name,
        'session_token': appCore.session_token
      };

      _app.request({
        url: api_url + 'customer_restaurant_listing_2.php',
        dataType: 'json',
        data: _request_params,
        method: 'POST',
        cache: false,
        crossDomain: true,
        success: function (restaurantsData) {
          console.log("restaurants data", restaurantsData);
          tagArray = new Array();
          console.log("tag array", tagArray);

          _self.$setState({
            data: restaurantsData,
            currentAddressData: {
              'address': mapManager.Current_Address
            }
          });

          if (restaurantsData.data == null) {
            f7app.dialog.alert("Siamo spiacenti, ma non è presente nessun ristorante nella tua zona!", "Attenzione");
          } else {
            show_tags(restaurantsData.data);
            console.log("qui", window.shared_restaurant); //seleziono un ristorante se arrivo dal link di condivisione

            if (window.shared_restaurant != undefined) {
              console.log(Array.from(restaurantsData.data, x => x.restaurant_id));

              if (Array.from(restaurantsData.data, x => x.restaurant_id).includes(window.shared_restaurant)) {
                ViewHome.router.navigate("/restaurants-products/?id=" + window.shared_restaurant);
              } else {
                f7app.dialog.alert("Siamo spiacenti, Il ristorante non è disponibile all'indirizzo inserito. Puoi comunque ordinare dai ristoranti che visualizzi, grazie! ", "Attenzione");
              }

              window.shared_restaurant = undefined;
            }
          }
        },
        error: function () {
          f7app.dialog.alert('Errore di connessione al server !', "Errore");
        }
      });

      $$('#address_input').attr('value', mapManager.Current_Address);
      $$('#address_input').on('click', function (e) {
        delete_filter();
      });
      $$('.restaurants_order').on('change', function (e) {
        restaurants_order = this.value;
        $$('#img-filter').prop('src', './static/images/imbutoAttivo.png');
      });
      $$('.restaurants_payment').on('change', function (e) {
        restaurants_payment = this.value;
        $$('#img-filter').prop('src', './static/images/imbutoAttivo.png');
      });
      $$('#delete-filter').on('click', function (e) {
        delete_filter(); //apply_remove_filter(_self);	
      });
      $$('.popover-about').on('popover:closed', function (e) {
        apply_remove_filter(_self);
      });
    },
    pageInit: function (e, page) {
      var self = this;
      var _app = self.$app;
    }
  },
  id: 'ae8717aabb',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page style="background-color: #fff;"><!-- Fixed/Dynamic Navbar --><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding" style=padding:10px;><div class=title style=width:100%><a style=width:100% href=/current-position-address/ ><input readonly=readonly id=address_input type=text style="height:35px; color:black; font-size:0.7em; display:inline-block;padding-right:30px;"><i class=f7-icons style="font-size:20px; margin-left:-25px;margin-top:-3px; color:black;">chevron_down</i></a></div><div class=right><a id=popover-about class="popover-open popover-about" href=# data-popover=.popover-about><img src=./static/images/imbuto.svg id=img-filter style="height:30px; vertical-align:top; margin-left:6px;"></a></div></div></div><!-- Scrollable page content--><div class=page-content><div class="popover popover-about" id=popover-box><div class=popover-inner><div class="card card-outline" style="max-height: 600px; overflow: auto;"><!--\r\n					<div class="card-header" style="background-color: #b11733; font-weight: bold; font-weight: bold; color: #fff; font-weight: bold; margin-bottom: 10px;">\r\n					\r\n						Filtri di ricerca\r\n\r\n					</div>\r\n					--><div class="card-content card-content-padding" style="padding-bottom: 0;"><div class=row><div class=col-100><button id=apply-filter class="col button button-small button-fill popover-close" style="min-height: 35px; margin-bottom: 5px; margin-top: 5px;">Applica filtri</button></div></div><div class=row><div class=col-100 style="text-align: center; font-weight: bold; font-size: 1.1em; margin-top: 10px;"><a id=delete-filter class=popover-close href=#>Cancella filtri</a></div></div></div><div class="card-content card-content-padding"><div class=block-title style="margin-top: 0; margin-bottom: 30px;">Nome ristorante</div><div class=block><input id=restaurants_name type=text style="display: inline; height: 35px; color: black; border:1px solid black;" value=""></div><div class=block-title>Ordina per</div><div class=list><ul><li><label class="item-radio item-content"><input type=radio class=restaurants_order name=order value=distance> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Distanza</div></div></label></li><li><label class="item-radio item-content"><input type=radio class=restaurants_order name=order value=min_order_amount> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Ordine minimo</div></div></label></li><li><label class="item-radio item-content"><input type=radio class=restaurants_order name=order value=shipping_cost> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Spese di spedizione</div></div></label></li></ul></div><div class=block-title>Metodo di pagamento</div><div class=list><ul><li style="margin:0px; padding:0px;"><label class="item-radio item-content"><input type=radio class=restaurants_payment name=payment value=0> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Contanti</div></div></label></li><li><label class="item-radio item-content"><input type=radio class=restaurants_payment name=payment value=1> <i class="icon icon-radio"></i><div class=item-inner><div class=item-title>Carte di credito</div></div></label></li></ul></div><div class=block-title style="margin-bottom: 30px;">Tipo di cucina</div><div class=block id=cuisine_type></div></div></div></div></div>';
      r += Template7Helpers.js_if.call(ctx_1, "typeof this.data === 'undefined'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<!-- Pagina caricamento --><div class="card skeleton-text skeleton-effect-wave"><div class=card-header>Card Header</div><div class="card-content card-content-padding">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</div></div><div class="list media-list"><ul><li class="item-content skeleton-text skeleton-effect-wave"><div class=item-media><div class=skeleton-block style="width: 40px; height: 40px; border-radius: 50%"></div></div><div class=item-inner><div class=item-title-row><div class=item-title>Title</div></div><div class=item-subtitle>Subtitle</div><div class=item-text>Placeholder text line 1<br>Text line 2</div></div></li><li class="item-content skeleton-text skeleton-effect-wave"><div class=item-media><div class=skeleton-block style="width: 40px; height: 40px; border-radius: 50%"></div></div><div class=item-inner><div class=item-title-row><div class=item-title>Title</div></div><div class=item-subtitle>Subtitle</div><div class=item-text>Placeholder text line 1<br>Text line 2</div></div></li><li class="item-content skeleton-text skeleton-effect-wave"><div class=item-media><div class=skeleton-block style="width: 40px; height: 40px; border-radius: 50%"></div></div><div class=item-inner><div class=item-title-row><div class=item-title>Title</div></div><div class=item-subtitle>Subtitle</div><div class=item-text>Placeholder text line 1<br>Text line 2</div></div></li></ul></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.js_if.call(ctx_1, "typeof this.data !== 'undefined'", {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.js_if.call(ctx_2, "this.data != null", {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += Template7Helpers.js_if.call(ctx_3, "this.data.data.length > 0", {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  r += Template7Helpers.js_if.call(ctx_4, "this.data.data.filter(x => x.openOrder === 'open').length > 0", {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '<!-- APERTI --><div class=title-category>Aperti ora:</div><div class=row><div class=col-100><div class=row style="padding:25px; border-radius:25px;">';
                      r += Template7Helpers.each.call(ctx_5, ctx_5.data.data, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += ' ';
                          r += Template7Helpers.js_if.call(ctx_6, "this.openOrder == 'open'", {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '<div class="col-100 xlarge-50 large-50 xsmall-100 small-100 box-restaurant">';
                              r += Template7Helpers.js_if.call(ctx_7, "this.active != 0", {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += ' <a href="/restaurants-products/?id=';
                                  r += c(ctx_8.restaurant_id, ctx_8);
                                  r += '"><div class="card restaurant demo-card-header-pic"><div class="card-header align-items-flex-end" style="--f7-card-header-border-color: none; height: 200px; background-size: 100% 200px; background-repeat: no-repeat; background-image:url(';
                                  r += Template7Helpers.js.call(ctx_8, 'restaurants_cover_img_url', {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += c(ctx_8.cover_image, ctx_8);
                                  r += ')"></div><div class=card-content style="padding-bottom: 15px;"><div class=div-restaurant style="box-shadow:0px; border:0px;"><span class=helper></span> <img src="';
                                  r += Template7Helpers.js.call(ctx_8, 'restaurants_img_url', {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += c(ctx_8.image, ctx_8);
                                  r += '" class=image-restaurant style="border: 2px solid #b11733; width: 70px; height: 70px;"></div><h3 class=title-restaurant>';
                                  r += Template7Helpers.escape.call(ctx_8, ctx_8.resturant_name, {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</h3>';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.active != 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<p class=paragraph-restaurant style="color: #b11733; font-weight: bold;">TEMPORANEAMENTE<br>NON DISPONIBILE</p>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.tags != null ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost > 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost == 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.cash_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.online_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      return r;
                                    },
                                    inverse: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<p class=paragraph-restaurant>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.tags != null ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' ';
                                          r += Template7Helpers.js.call(ctx_10, "this.tags.replace(/-/g, ' &bull; ')", {
                                            hash: {},
                                            data: data_10 || {},
                                            fn: function empty() {
                                              return '';
                                            },
                                            inverse: function empty() {
                                              return '';
                                            },
                                            root: root,
                                            parents: [ctx_9, ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                          });
                                          r += ' ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += '</p><p class=paragraph-restaurant>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost > 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' Consegna: ';
                                          r += c(ctx_10.shipping_cost, ctx_10);
                                          r += ' &euro; &#8226; ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost == 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' Consegna: <b>GRATIS</b> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' Ordine minimo: ';
                                      r += c(ctx_9.min_order_amount, ctx_9);
                                      r += ' &euro;</p><p class=paragraph-restaurant><img src=./static/images/marker_icon.svg style="width: 13px;vertical-align: text-bottom;"> ';
                                      r += c(ctx_9.distance, ctx_9);
                                      r += ' Km &#8226; Pagamento: ';
                                      r += Template7Helpers.js_if.call(ctx_9, "this.cash_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' &#8226; <img src=./static/images/money.png style="width: 22px;"> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      r += Template7Helpers.js_if.call(ctx_9, "this.online_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' &#8226; <img src=./static/images/credit_card_icon.png style="width: 20px; margin-left:2px"> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += '</p>';
                                      return r;
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</div></div></a>';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.active != 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.tags != null ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost > 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost == 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.cash_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.online_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  return r;
                                },
                                inverse: function (ctx_8, data_8) {
                                  var r = '';
                                  r += ' <a href=#><div class="card restaurant demo-card-header-pic" style=background:#aaaaaa><div class="card-header align-items-flex-end" style="--f7-card-header-border-color: none; height: 200px; background-size: 100% 200px; background-repeat: no-repeat; background-image:url(';
                                  r += Template7Helpers.js.call(ctx_8, 'restaurants_cover_img_url', {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += c(ctx_8.cover_image, ctx_8);
                                  r += ')"></div><div class=card-content style="padding-bottom: 15px;"><div class=div-restaurant style="box-shadow:0px; border:0px;"><span class=helper></span> <img src="';
                                  r += Template7Helpers.js.call(ctx_8, 'restaurants_img_url', {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += c(ctx_8.image, ctx_8);
                                  r += '" class=image-restaurant style="border: 2px solid #b11733; width: 70px; height: 70px;"></div><h3 class=title-restaurant>';
                                  r += Template7Helpers.escape.call(ctx_8, ctx_8.resturant_name, {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</h3>';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.active != 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<p class=paragraph-restaurant style="color: #b11733; font-weight: bold;">TEMPORANEAMENTE<br>NON DISPONIBILE</p>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.tags != null ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost > 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost == 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.cash_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += Template7Helpers.js_if.call(ctx_9, "this.online_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      return r;
                                    },
                                    inverse: function (ctx_9, data_9) {
                                      var r = '';
                                      r += '<p class=paragraph-restaurant>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.tags != null ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' ';
                                          r += Template7Helpers.js.call(ctx_10, "this.tags.replace(/-/g, ' &bull; ')", {
                                            hash: {},
                                            data: data_10 || {},
                                            fn: function empty() {
                                              return '';
                                            },
                                            inverse: function empty() {
                                              return '';
                                            },
                                            root: root,
                                            parents: [ctx_9, ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                          });
                                          r += ' ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += '</p><p class=paragraph-restaurant>';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost > 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' Consegna: ';
                                          r += c(ctx_10.shipping_cost, ctx_10);
                                          r += ' &euro; &#8226; ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      r += Template7Helpers.js_if.call(ctx_9, " this.shipping_cost == 0 ", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' Consegna: <b>GRATIS</b> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' Ordine minimo: ';
                                      r += c(ctx_9.min_order_amount, ctx_9);
                                      r += ' &euro;</p><p class=paragraph-restaurant><img src=./static/images/marker_icon.svg style="width: 13px;vertical-align: text-bottom;"> ';
                                      r += c(ctx_9.distance, ctx_9);
                                      r += ' Km &#8226; Pagamento: ';
                                      r += Template7Helpers.js_if.call(ctx_9, "this.cash_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' &#8226; <img src=./static/images/money.png style="width: 22px;"> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      r += Template7Helpers.js_if.call(ctx_9, "this.online_payment_enabled == 1", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function (ctx_10, data_10) {
                                          var r = '';
                                          r += ' &#8226; <img src=./static/images/credit_card_icon.png style="width: 20px; margin-left:2px"> ';
                                          return r;
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += '</p>';
                                      return r;
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</div></div></a>';
                                  return r;
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div>';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += ' ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += '</div></div></div>';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '<!-- CHIUSI --><div class=title-category>Ordina per più tardi:</div><div class=row><div class=col-100><div class=row style="padding:25px; border-radius:25px;">';
                  r += Template7Helpers.each.call(ctx_4, ctx_4.data.data, {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += ' ';
                      r += Template7Helpers.js_if.call(ctx_5, "this.openOrder == 'close'", {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '<div class="col-100 xlarge-50 large-50 xsmall-100 small-100 box-restaurant">';
                          r += Template7Helpers.js_if.call(ctx_6, "this.active != 0", {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += ' <a href="/restaurants-products/?id=';
                              r += c(ctx_7.restaurant_id, ctx_7);
                              r += '"><div class="card restaurant demo-card-header-pic"><div class="card-header align-items-flex-end" style="--f7-card-header-border-color: none; height: 200px; background-size: 100% 200px; background-repeat: no-repeat; background-image:url(';
                              r += Template7Helpers.js.call(ctx_7, 'restaurants_cover_img_url', {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += c(ctx_7.cover_image, ctx_7);
                              r += ')"></div><div class=card-content style="padding-bottom: 15px;"><div class=div-restaurant style="box-shadow:0px; border:0px;"><span class=helper></span> <img src="';
                              r += Template7Helpers.js.call(ctx_7, 'restaurants_img_url', {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += c(ctx_7.image, ctx_7);
                              r += '" class=image-restaurant style="border: 2px solid #b11733; width: 70px; height: 70px;"></div><h3 class=title-restaurant>';
                              r += Template7Helpers.escape.call(ctx_7, ctx_7.resturant_name, {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</h3>';
                              r += Template7Helpers.js_if.call(ctx_7, "this.active != 1", {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += '<p class=paragraph-restaurant style="color: #b11733; font-weight: bold;">TEMPORANEAMENTE<br>NON DISPONIBILE</p>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.tags != null ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost > 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost == 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.cash_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.online_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  return r;
                                },
                                inverse: function (ctx_8, data_8) {
                                  var r = '';
                                  r += '<p class=paragraph-restaurant>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.tags != null ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' ';
                                      r += Template7Helpers.js.call(ctx_9, "this.tags.replace(/-/g, ' &bull; ')", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</p><p class=paragraph-restaurant>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost > 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' Consegna: ';
                                      r += c(ctx_9.shipping_cost, ctx_9);
                                      r += ' &euro; &#8226; ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost == 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' Consegna: <b>GRATIS</b> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' Ordine minimo: ';
                                  r += c(ctx_8.min_order_amount, ctx_8);
                                  r += ' &euro;</p><p class=paragraph-restaurant><img src=./static/images/marker_icon.svg style="width: 13px;vertical-align: text-bottom;"> ';
                                  r += c(ctx_8.distance, ctx_8);
                                  r += ' Km &#8226; Pagamento: ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.cash_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' &#8226; <img src=./static/images/money.png style="width: 22px;"> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.online_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' &#8226; <img src=./static/images/credit_card_icon.png style="width: 20px; margin-left:2px"> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</p>';
                                  return r;
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div></div></a>';
                              r += Template7Helpers.js_if.call(ctx_7, "this.active != 1", {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.tags != null ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost > 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost == 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.cash_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.online_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  return r;
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              return r;
                            },
                            inverse: function (ctx_7, data_7) {
                              var r = '';
                              r += ' <a href=#><div class="card restaurant demo-card-header-pic" style=background:#aaaaaa><div class="card-header align-items-flex-end" style="--f7-card-header-border-color: none; height: 200px; background-size: 100% 200px; background-repeat: no-repeat; background-image:url(';
                              r += Template7Helpers.js.call(ctx_7, 'restaurants_cover_img_url', {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += c(ctx_7.cover_image, ctx_7);
                              r += ')"></div><div class=card-content style="padding-bottom: 15px;"><div class=div-restaurant style="box-shadow:0px; border:0px;"><span class=helper></span> <img src="';
                              r += Template7Helpers.js.call(ctx_7, 'restaurants_img_url', {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += c(ctx_7.image, ctx_7);
                              r += '" class=image-restaurant style="border: 2px solid #b11733; width: 70px; height: 70px;"></div><h3 class=title-restaurant>';
                              r += Template7Helpers.escape.call(ctx_7, ctx_7.resturant_name, {
                                hash: {},
                                data: data_7 || {},
                                fn: function empty() {
                                  return '';
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</h3>';
                              r += Template7Helpers.js_if.call(ctx_7, "this.active != 1", {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += '<p class=paragraph-restaurant style="color: #b11733; font-weight: bold;">TEMPORANEAMENTE<br>NON DISPONIBILE</p>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.tags != null ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost > 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost == 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.cash_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += Template7Helpers.js_if.call(ctx_8, "this.online_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function empty() {
                                      return '';
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  return r;
                                },
                                inverse: function (ctx_8, data_8) {
                                  var r = '';
                                  r += '<p class=paragraph-restaurant>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.tags != null ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' ';
                                      r += Template7Helpers.js.call(ctx_9, "this.tags.replace(/-/g, ' &bull; ')", {
                                        hash: {},
                                        data: data_9 || {},
                                        fn: function empty() {
                                          return '';
                                        },
                                        inverse: function empty() {
                                          return '';
                                        },
                                        root: root,
                                        parents: [ctx_8, ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                      });
                                      r += ' ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</p><p class=paragraph-restaurant>';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost > 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' Consegna: ';
                                      r += c(ctx_9.shipping_cost, ctx_9);
                                      r += ' &euro; &#8226; ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  r += Template7Helpers.js_if.call(ctx_8, " this.shipping_cost == 0 ", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' Consegna: <b>GRATIS</b> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' Ordine minimo: ';
                                  r += c(ctx_8.min_order_amount, ctx_8);
                                  r += ' &euro;</p><p class=paragraph-restaurant><img src=./static/images/marker_icon.svg style="width: 13px;vertical-align: text-bottom;"> ';
                                  r += c(ctx_8.distance, ctx_8);
                                  r += ' Km &#8226; Pagamento: ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.cash_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' &#8226; <img src=./static/images/money.png style="width: 22px;"> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += ' ';
                                  r += Template7Helpers.js_if.call(ctx_8, "this.online_payment_enabled == 1", {
                                    hash: {},
                                    data: data_8 || {},
                                    fn: function (ctx_9, data_9) {
                                      var r = '';
                                      r += ' &#8226; <img src=./static/images/credit_card_icon.png style="width: 20px; margin-left:2px"> ';
                                      return r;
                                    },
                                    inverse: function empty() {
                                      return '';
                                    },
                                    root: root,
                                    parents: [ctx_7, ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                                  });
                                  r += '</p>';
                                  return r;
                                },
                                root: root,
                                parents: [ctx_6, ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                              });
                              r += '</div></div></a>';
                              return r;
                            },
                            root: root,
                            parents: [ctx_5, ctx_4, ctx_3, ctx_2, ctx_1]
                          });
                          r += '</div>';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [ctx_4, ctx_3, ctx_2, ctx_1]
                      });
                      r += ' ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</div></div></div>';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=block>Non ci sono ristoranti corrispondenti ai criteri di ricerca selezionati</div>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div>';
      return r;
    }(this);
  },

  style: `
  .demo-card-header-pic .card-heade {
    height: 200px;
    background-size: cover;
    background-position: center;
    color: #fff;
  }
    .demo-card-header-pic .card-content-padding .date {
    color: red;
  }
  .image-restaurant{
	max-height:76px;
    width: 76px;
	padding:0px;
	margin-top:-50px;
	
  }
  
  .div-restaurant{
	height:76px;
	width:76px;
	margin:-38px auto;
	text-align: center;
	display: flex;
    align-items: center;
    justify-content: center;
  }
  .helper {
	display: inline-block;
	height: 100%;
	vertical-align: middle;
	
	}
  
  .title-restaurant{
	text-align:center;
	font-weight:bold;
	font-size:1.3em;
	color:black;
	margin:20px 0 5px 0;
  }
  .paragraph-restaurant{
	text-align:center;
	color:black;
	margin:0px;
	font-size:1em;
  } 
  .paragraph-restaurant img{
	vertical-align: middle;
  }
  .intro{
	color:green;
  }
  
.popover-block{
	margin:4px;
}

#popover-box{
	width:90%;
	max-width:400px;
}
#address_input{
	cursor: pointer;
}

.title-category{
	color:#000000;
	padding:6px;
	font-weight:bold; 
	margin:10px 10px -10px 10px; 
	text-align:center; 
	font-size:1.7em;
}

.restaurant .card-header{
	border-top-left-radius:25px;
	border-top-right-radius:25px;
	
}

.restaurant{
	border-radius:25px;
	box-shadow: 7px 7px 7px #777777;
	margin-bottom:15px;
}


`,
  styleScoped: false
};

function apply_remove_filter(self) {
  var _self = self;
  var _app = _self.$app;
  restaurants_name = $$('#restaurants_name').prop('value');
  restaurants_tag = "";
  var restaurants_tag_filter = false;
  tagSearchArray = [];
  $$('.restaurants_tag').each(function (index) {
    if (this.checked) {
      var _tag = this.value;
      restaurants_tag = restaurants_tag + "," + _tag;
      restaurants_tag_filter = true;
      tagSearchArray.push(_tag);
    }
  });

  if (restaurants_tag_filter == true) {
    $$('#img-filter').prop('src', './static/images/imbutoAttivo.png');
  }

  if (restaurants_name != "") {
    $$('#img-filter').prop('src', './static/images/imbutoAttivo.png');
  }

  let _request_params = {
    'latitude': mapManager.Current_Location.lat,
    'longitude': mapManager.Current_Location.lng,
    'restaurants_order': restaurants_order,
    'restaurants_payment': restaurants_payment,
    'restaurants_tag': restaurants_tag,
    'restaurants_name': restaurants_name,
    'session_token': appCore.session_token
  };

  _app.request({
    url: api_url + 'customer_restaurant_listing_2.php',
    dataType: 'json',
    data: _request_params,
    method: 'POST',
    cache: false,
    crossDomain: true,
    success: function (restaurantsData) {
      console.log("restaurants data", restaurantsData);
      tagArray = new Array();
      console.log("tag array", tagArray);

      _self.$setState({
        data: restaurantsData,
        currentAddressData: {
          'address': mapManager.Current_Address
        }
      });

      if (restaurantsData.data == null) {
        f7app.dialog.alert("Siamo spiacenti, ma non è presente nessun ristorante nella tua zona che rispetti i criteri selezionati!", "Attenzione");

        if (restaurants_payment != "" || restaurants_tag != "" || restaurants_name != "") {
          delete_filter();
          apply_remove_filter(_self);
        }
      } else {
        show_tags(restaurantsData.data);
      }
    },
    error: function () {
      f7app.dialog.alert('Errore di connessione al server !', "Errore");
    }
  });
}

function delete_filter() {
  restaurants_payment = "";
  restaurants_tag = "";
  restaurants_order = "default";
  restaurants_name = "";
  $$('#restaurants_name').prop('value', '');
  $$('input[type="radio"]').removeAttr('checked');
  $$('input[type="radio"]').prop('checked', false);
  $$('input[type="checkbox"]').removeAttr('checked');
  $$('input[type="checkbox"]').prop('checked', false);
  $$('#img-filter').prop('src', './static/images/imbuto.svg');
  tagSearchArray = [];
}

function show_tags(restaurantData) {
  var tagHTML = "";

  for (var i = 0; i < restaurantData.length; i = i + 1) {
    if (restaurantData[i]["tags"] != null) {
      var tags = restaurantData[i]["tags"].split(" - ");

      for (var j = 0; j < tags.length; j++) {
        let _tag = tags[j];

        if (tagArray.includes(_tag) == false) {
          tagArray.push(_tag);
          tagHTML = tagHTML + "<div class='chip' style='margin-right:5px;'>";
          tagHTML = tagHTML + "<div class='chip-label'>";
          tagHTML = tagHTML + "<label class='item-checkbox item-content'>";
          tagHTML = tagHTML + "<input type='checkbox' class='restaurants_tag' name='tag' value='" + _tag + "'";
          tagHTML = tagHTML + (tagSearchArray.includes(_tag) == true ? "checked" : "") + "/>";
          tagHTML = tagHTML + "<div class='item-inner'>";
          tagHTML = tagHTML + "<div class='item-title'><i class='icon icon-checkbox' style='margin-right:5px;'></i>" + _tag + "</div>";
          tagHTML = tagHTML + "</div>";
          tagHTML = tagHTML + "</label>";
          tagHTML = tagHTML + "</div>";
          tagHTML = tagHTML + "</div>";
        }
      }
    }
  }

  $$('#cuisine_type').html(tagHTML);
}
    